module.exports = __webpack_public_path__ + "img/about_team_icon.1c33b380.png";